import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { DataTable } from '../../../components/DataTable/DataTable';
import { useDataTable } from '../../../components/DataTable/useDataTable';
import Dialog from '../../../components/dialog/Dialog';
import { ClienteService } from '../../../services/ClienteService';
import ACCESS from '../../../ACCESS';

const Clientes = () => {
    const history = useHistory();
    const tableState = useDataTable({ initialLimit: 15 });

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dialog, setDialog] = useState({ show: false, title: '', options: ['Sí', 'No'], row: null });

    const fetchData = useCallback(async () => {
        setLoading(true);
        const rows = await ClienteService.obtenerLista(
            tableState.page,
            tableState.limit,
            tableState.filters,
            tableState.orderBy,
            tableState.order
        );
        setData(rows);
        setLoading(false);
    }, [tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const hasMore = data.length === tableState.limit;

    const columns = [
        { id: 'cliente', label: 'Cliente' },
        { id: 'cliente_rsocial', label: 'Razón Social' },
        { id: 'cliente_rfc', label: 'RFC' },
        {
            id: 'genero',
            label: 'F/M',
            render: (row) => {
                const isFisica = Number(row.cliente_fm) === 1 || row.genero === 'Fisica';
                const isMoral = Number(row.cliente_fm) === 2 || row.genero === 'Moral';
                return (
                    <span
                        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                            isFisica
                                ? 'bg-blue-50 text-blue-700 border border-blue-200'
                                : isMoral
                                ? 'bg-purple-50 text-purple-700 border border-purple-200'
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        {isFisica ? 'Física' : isMoral ? 'Moral' : (row.genero || '-')}
                    </span>
                );
            },
        },
        {
            id: 'cliente_dv',
            label: 'DV',
            render: (row) => (
                <span
                    className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                        row.cliente_dv
                            ? 'bg-amber-50 text-amber-800 border border-amber-200'
                            : 'bg-gray-50 text-gray-400'
                    }`}
                >
                    {row.cliente_dv ? 'Sí' : 'No'}
                </span>
            ),
        },
        { id: 'cliente_desc', label: 'Descripción' },
    ];

    const handleDeleteClick = (row) => {
        setDialog({
            show: true,
            title: `¿Borrar el cliente ${row.cliente_rsocial || row.cliente}?`,
            options: ['Sí', 'No'],
            row: row,
        });
    };

    const handleDialogClose = async (op) => {
        const rowToDelete = dialog.row;
        setDialog({ show: false, title: '', options: [], row: null });

        if (op === 1 && rowToDelete) {
            setLoading(true);
            const success = await ClienteService.eliminar(rowToDelete);
            if (success) {
                fetchData();
            } else {
                setLoading(false);
            }
        }
    };

    const actions = [
        {
            id: 'edit',
            icon: 'edit',
            tooltip: 'Editar cliente',
            access: ACCESS.CATALOGO_CLIENTES.EDITAR_CATALOGO,
            onClick: (actionId, row) => history.push(`/Catalogo/Cliente/${row.id}/Generales`),
        },
        {
            id: 'delete',
            icon: 'delete',
            tooltip: 'Eliminar cliente',
            access: ACCESS.CATALOGO_CLIENTES.ELIMINAR_CATALOGO,
            onClick: (actionId, row) => handleDeleteClick(row),
        },
    ];

    return (
        <div className="w-full">
            <DataTable
                columns={columns}
                data={data}
                loading={loading}
                actions={actions}
                hasMore={hasMore}
                page={tableState.page}
                limit={tableState.limit}
                onPageChange={tableState.handlePageChange}
                onLimitChange={tableState.handleLimitChange}
                orderBy={tableState.orderBy}
                order={tableState.order}
                onSort={tableState.handleSort}
                filters={tableState.filters}
                onFilterChange={tableState.handleFilterChange}
                onRowClick={(row) => history.push(`/Catalogo/Cliente/${row.id}/Generales`)}
            />
            <Dialog dialog={dialog} onClose={handleDialogClose} />
        </div>
    );
};

export default Clientes;
